import { NEEDLE_AND_SHARP_CHECKLIST } from './needleAndSharpPolicy';
import { SIREN_NUTRITION_ITEM } from './sirenBundlePolicy';

export type ChecklistSection = {
  title?: string;
  description?: string;
  note?: string;
  items: string[];
};

const CHECKLISTS: Record<string, ChecklistSection[]> = {
  "บันทึกทางการพยาบาล": [
    {
      items: [
        "เกณฑ์ข้อ 1 การประเมินแรกรับ",
        "เกณฑ์ข้อ 2 การระบุปัญหาทางการพยาบาล",
        "เกณฑ์ข้อ 3 กิจกรรมการพยาบาล",
        "เกณฑ์ข้อ 4 การตอบสนองการรักษาพยาบาล",
        "เกณฑ์ข้อ 5 การให้ข้อมูลระหว่างการดูแล",
        "เกณฑ์ข้อ 6 การเตรียมความพร้อมผู้ป่วยเพื่อการดูแลตนเองต่อเนื่องที่บ้าน",
        "เกณฑ์ข้อ 7 การประสานการดูแลต่อเนื่อง",
        "เกณฑ์ข้อ 8 การเตรียมผู้ป่วยก่อนจำหน่าย",
        "เกณฑ์ข้อ 9 การบันทึกวันเดือนปี เวลา การลงลายมือชื่อ",
      ],
    },
  ],
  "เข็มตำ/ของมีคมบาด": NEEDLE_AND_SHARP_CHECKLIST,
  "นิเทศระบบยา": [
    {
      title: "การรับคำสั่ง",
      items: [
        "ตรวจสอบความถูกต้องซ้ำในใบ MAR กับคำสั่งรายการยาของแพทย์",
        "\"High Alert Drug\" มีการตรวจสอบร่วมกันในคำสั่งยา (Double check) กรณีที่มีพยาบาลปฏิบัติหน้าที่คนเดียว สามารถตรวจสอบซ้ำด้วยตนเองได้ (Recheck)",
        "ประสานกับแพทย์ กรณีที่คำสั่งไม่ชัดเจน หรือไม่ถูกต้อง",
      ],
    },
    {
      title: "การรับยา",
      items: [
        "ตรวจสอบยาที่รับจากห้องยากับใบนำส่งให้ถูกต้อง ก่อนจัดเก็บยาเข้ากล่องบรรจุ",
        "ประสานเภสัชกร กรณีได้รับยาไม่ถูกต้อง ไม่ครบถ้วน",
      ],
    },
    {
      title: "การจัดเก็บยา",
      items: [
        "จัดเก็บยาสำหรับผู้ป่วยเฉพาะราย",
        "\"High Alert Drug\" จัดเก็บแยกจากยาอื่น - ติดเครื่องหมายที่กล่องบรรจุยา / Syringe ยา / ชื่อยาในใบ MAR",
        "ยา LASA มีป้ายติดที่ซองยา / ภาชนะที่จัดเก็บ / ใบ MAR",
        "ยา Multiple dose มี Sticker เริ่มใช้ / หมดอายุ",
        "ยาเสพติดแยกเก็บจากยาอื่น ใส่ลิ้นชักมีกุญแจล็อค",
        "มีการตรวจสอบการใช้ยาเสพติด โดยลงบันทึกในแบบฟอร์มการบันทึกการใช้ยาเสพติด",
      ],
    },
    {
      title: "การบริหารยา (ใช้หลัก 7R)",
      items: [
        "จัดยาตามใบ MAR โดยตรวจสอบยาในซองยาให้ถูกต้องตรงกัน",
        "Double check / Recheck ก่อนให้ยา",
        "\"High Alert Drug\" มีการใช้ Infusion pump, Syringe pump หรือ ควบคุมจำนวนหยด",
        "\"High Alert Drug\" ตรวจสอบจำนวนหยดร่วมกัน (Double check)",
        "ตรวจสอบระบุตัวถูกต้อง โดยตรวจสอบป้ายข้อมือให้ตรงกับ Sticker ยาและใบ MAR",
        "กรณีให้สารน้ำหรือสารละลาย ติด Sticker :- Start, Expire ที่ IV Site ของผู้ป่วยทุกราย",
        "กรณีให้สารน้ำหรือสารละลาย ติดป้ายบ่งชี้ที่ขวดพร้อมลงข้อมูลครบถ้วน",
        "ให้ข้อมูลผู้ป่วย / ญาติเมื่อให้ยา",
        "บันทึกเวลาที่ให้ยาจริง (Realtime) และบันทึกชื่อพยาบาลผู้ให้ในใบ MAR ทุกครั้ง",
        "บันทึกการพยาบาลเฝ้าระวัง \"High Alert Drug\" เกี่ยวกับ - ความเสี่ยงที่อาจเกิดขึ้นจากการที่ผู้ป่วยได้รับยา - การสังเกตอาการไม่พึงประสงค์ - การให้ข้อมูลแก่ผู้ป่วย/ผู้ดูแล",
        "มีการ Round สารน้ำหรือสารละลายเพื่อตรวจสอบความถูกต้องตรงกับคำสั่งการรักษา - \"High Alert Drug Round ทุก 1-2 ชั่วโมง - สารน้ำทั่วไป Round IV อย่างน้อยทุก 4 ชั่วโมง",
      ],
    },
    {
      title: "การตรวจสอบอื่น ๆ",
      items: [
        "ยาสำรองตามระบบมีบันทึกการตรวจสอบความพร้อมใช้ทุกเวร",
        "CPR box มีสายคาด สภาพพร้อมใช้",
        "ไม่พบยาค้าง / ยาที่แพทย์สั่ง off ในกล่องบรรจุยาผู้ป่วย",
        "มีการตรวจสอบอุณหภูมิตู้เย็นเก็บยา ตามข้อกำหนด",
        "สถานที่จัดยา \"สงบ สะอาด สว่าง\"",
      ],
    },
  ],
  "SIREN bundle": [
    {
      title: "SKIN",
      items: [
        "1. ประเมินสภาพผิวหนังตั้งแต่แรกรับ โดยเฉพาะตามปุ่มกระดูก",
        "2. บำรุงผิวให้มีความชุ่มชื้นโดยการทาโลชั่น หรือปิโตรเลียมออยท์เม้นท์แต่ไม่เปียกแฉะ",
        "3. ใช้วัสดุปิดแผล ปิดที่ร่องหูบริเวณเชือกผูกท่อช่วยหายใจพาดผ่าน ( กรณีไม่ใส่ท่อช่วยหายใจให้ ใส่ NA ในข้อนี้ )",
      ],
    },
    {
      title: "Incontinence",
      items: [
        "1.ทำความสะอาดผิวหนังทุกครั้งเมื่อมีการขับถ่าย และซับให้แห้ง",
        "2.หลีกเลี่ยงการขัดถูผิวหนังอย่างรุนแรงปกป้องผิวหนังจากการสัมผัสสิ่งขับถ่ายด้วยผลิตภัณฑ์ต่างๆเช่น วาสลิน",
        "3.ใช้ครีมปกป้องผิวหนังทา / พ่นเมื่อเกิดความเสียหายของผิวหนัง",
      ],
    },
    {
      title: "Relief",
      items: [
        "1. พลิกตะแคงตัวทุก 2 ชั่วโมง",
        "2. ใช้ที่นอนลมในผู้ป่วยที่มีความเสี่ยง (โดยเฉพาะBraden ≤14 ต้อง ใช้ทุกราย)",
        "3. ใช้ผ้ารองในการยกตัวผู้ป่วย ไม่ดึง-ลากผู้ป่วย",
      ],
    },
    {
      title: "Evaluation",
      items: [
        "1. ประเมินความเสี่ยงการเกิดแผลกดทับโดยใช้ Braden Scoreและบันทึกลงใน Intervention ในรายที่มีความเสี่ยง ( คะแนน≤18) โดยประเมินซ้ำทุกวัน",
        "2. ประเมิน DTI ในผู้ป่วยที่มีการใช้อุปกรณ์ทางการแพทย์ทุกครั้งทึ่มีการ Turn Position ป้องกันภาวะ Medical Device Related Pressure Injury  ( MDRPI )( กรณีไม่ใส่ท่อช่วยหายใจ ใส่ NA ในข้อนี้ )",
      ],
    },
    {
      title: "Nutrition",
      description: "มีการประเมินโภชนาการ โดยมีผลประเมินดังนี้ (*ถ้าใช่ = 1 คะแนน* , *ถ้าไม่ = 0 คะแนน*)",
      note: "หากคะแนนมากกว่าเท่ากับ 2 ให้ปรึกษานักโภชนาการ หากน้อยกว่าให้คัดกรองซ้ำทุกสัปดาห์",
      items: [SIREN_NUTRITION_ITEM],
    },
  ],
};

export const getChecklist = (title: string) => CHECKLISTS[title] || [];
